import React from 'react'
import Link from 'gatsby-link'
import Avatar from '../../images/avatar.jpg'




class Header extends React.Component {

  state = {
    menuState: 'nav-icon1 closed'
  }

  changeMenu = () => {
    if (this.state.menuState == 'nav-icon1 closed') { 
      this.setState({menuState: 'nav-icon1 open'})
    } else {
      this.setState({menuState: 'nav-icon1 closed'})
    }
  }



  render() {

    return (
      <div className="sub-hero">
        <header className="container">
          <div className="header-child">
              <img className="avatar header-child-child" src={Avatar} />
              <h4 className="header-child-child">Nathan Gaw // Spyke Digital</h4>
          </div>
          {/*<div className="nav">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <a href="/work">Work</a>
              <a href="/contact">Contact</a>
          </div>
          <div className={this.state.menuState} onClick={ () => this.changeMenu() }>
            <span></span>
            <span></span>
            <span></span>
    </div>*/}
        </header>
      </div>
    )

  }

}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js